import AuditService from '@/service/audit'
export default {
  getChecklistItemOfGroupChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.getChecklistItemOfGroupChecklist(payload.checklist, payload.group_checklist_item, payload.select_status).then(res => {
        commit('getChecklistItemOfGroupChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getUserOfChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.getUserOfChecklist(payload.checklist).then(res => {
        commit('getUserOfChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getGroupOfChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.getGroupOfChecklist(payload.checklist, payload.select_status).then(res => {
        commit('getGroupOfChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  changeStatusChecklistItemOfChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.changeStatusChecklistItemOfChecklist(payload.checklist, payload.checklist_item, payload.status).then(res => {
        commit('changeStatusChecklistItemOfChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  quickReport ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.quickReport(payload.checklist).then(res => {
        commit('quickReport', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  history ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.history(payload.checklist, payload.checklist_item).then(res => {
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  setSelectStatus ({commit}, payload) {
    commit('setSelectStatus', payload)
  },
  clearSelectStatus ({commit}, payload) {
    commit('clearSelectStatus', payload)
  },
  searchChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.searchChecklist(payload.checklist, payload.search).then(res => {
        commit('getChecklistItemOfGroupChecklist', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  showChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.showChecklistItem(payload.checklist, payload.checklist_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  setCorrectiveDate ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.setCorrectiveDate(payload.checklist, payload.checklist_item).then(res => {
        resolve(res.data.data)
        // commit('setCorrectiveDate', res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  setCorrectiveStatus ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.setCorrectiveStatus(payload.checklist, payload.checklist_item).then(res => {
        resolve(res.data.data)
        // commit('setCorrectiveDate', res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getChecklistItemOfChecklist ({commit}, payload) {
    return new Promise((resolve, reject) => {
      AuditService.getChecklistItemOfChecklist(payload.checklist).then(res => {
        resolve(res.data.data)
        // commit('setCorrectiveDate', res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/audit/actions.js